// import { useSelector } from 'react-redux';

import { ThemeProvider, createTheme } from "@mui/material/styles";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { arEG } from "@mui/material/locale";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import "./App.css";
import extandDayjs from "./helpers/dayjs";
import NotificationSnackbar from "../src/components/Notification";
import { LicenseInfo } from "@mui/x-license-pro";

// routing
import Routes from "./routes";

// defaultTheme
import themes from "./themes";

// project imports
import NavigationScroll from "./layout/NavigationScroll";
import themeTypography from "./themes/typography";
import mycolors from "./assets/scss/_themes-vars.module.scss";
import themePalette from "./themes/palette";
import ConfirmationDialog from "./components/ConfirmationDialog";

// ==============================|| APP ||============================== //

const App = () => {
  LicenseInfo.setLicenseKey(
    "186a4fab9c1d8ad1a6680236cc5071c9Tz01ODIzMCxFPTE3MDYwMDYzODgwMzQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI="
  );

  const border_shadow = {
    borderRadius: 10,
    boxShadow:
      "rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 12px 24px -4px",
  };
  const theme = createTheme(
    {
      components: {
        MuiTypography: {
          defaultProps: {
            fontFamily: "Cairo",
          },
        },

        // Name of the component
        MuiCard: {
          styleOverrides: {
            root: {
              borderRadius: border_shadow.borderRadius,
              boxShadow: border_shadow.boxShadow,
            },
          },
        },
        MuiDataGrid: {
          styleOverrides: {
            root: {
              borderRadius: border_shadow.borderRadius,
              boxShadow: border_shadow.boxShadow,
            },
          },
        },
        // MuiListItemText: {
        //   styleOverrides: {
        //     primary: {
        //       // color: 'b'
        //     },
        //     "&:hover": {
        //       backgroundColor: "blue",
        //       color: "green"
        //     }
        //   }
        // },
      },
      palette: {
        type: "light",
        primary: {
          main: "#6941c5",
          contrastText: "#ffffff",
          light: "#6941c543",
        },
        secondary: {
          main: "#340E58",
        },
      },
      typography: themeTypography,
      direction: "rtl",
    },
    arEG
  );
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });

  return (
    <StyledEngineProvider injectFirst>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <ConfirmationDialog />
          <CssBaseline />
          <NotificationSnackbar />
          <NavigationScroll>
            <Routes />
          </NavigationScroll>{" "}
        </ThemeProvider>{" "}
      </CacheProvider>{" "}
    </StyledEngineProvider>
  );
};

export default App;
